import './grid_section_mobile_layout.less';

import React, { Component } from 'react';
import PropTypes from 'prop-types';

import map from 'lodash/map';
import defer from 'lodash/defer';
import filter from 'lodash/filter';

import GridTileForMobileContainer from './grid_tile_for_mobile_container.jsx';

import userAgentDetect from 'zoomforth_zfutils/useragent_detect.js';

import {
  APP_CONTAINER_SELECTOR
} from 'zoomforth_codesbane_viewer/const/dom_selectors.js';


class GridSectionMobileLayout extends Component {
  
  constructor(props) {
    super(props);
  }
  
  componentDidMount() {
    this.fixIosScrollIssue();
  }
  
  // see http://runastartup.com/overlay-scrolling-issues-on-iphone-ipad/
  // basically, the fact that app container is webkit overflow scroll
  // means that sometimes it fails to add a scroll bar 
  // for content that changes size inside of it
  // has apple fixed this by now, or does it work better in react? Maybe.
  // The TODO would be that we need a physical phone to test to see if we can get rid of this bit of code.
  fixIosScrollIssue() {
    if (userAgentDetect.isMobile.iOS()) {
      const $appContainer = $(APP_CONTAINER_SELECTOR);
      $appContainer.css('overflow', 'hidden');
      defer(function(){
        $appContainer.css('overflow', 'auto');
      });        
    }
  }
  
  render() {    
    // why sectionWidth for a mobile layout? if the display is changed from
    // landscape to portrait or vice versa we want to ensure content resizes
    // like the user would expect it to.
    const { gridPositions, subpage, sectionWidth } = this.props;
    
    return (
      <div className="tiles-container">
        {
          map(filter(gridPositions, 'uuid'), (gridPos) =>

            <GridTileForMobileContainer
              key={gridPos.uuid} 
              subpage={subpage} 
              sectionWidth={sectionWidth}
              {...gridPos}
            />

          )
        }
      </div>
    );
    
  }

}


GridSectionMobileLayout.propTypes = {
  gridPositions: PropTypes.array.isRequired
};

export default GridSectionMobileLayout;

